import React from "react";
import Index from "../../Index";
import "./defaultLayout.css";
import "./defaultLayout.responsive.css";
import PagesIndex from "../../../container/pages/business/PagesIndex";

const Footer = () => {
  return (
    <>
      <Index.Box className="footer-user-main">
        <Index.Box className="container-user">
          <Index.Box className="footer-user-menu">
            <Index.Typography
              variant="body1"
              component="p"
              className="footer-user-typo"
            >
              Follow Us
            </Index.Typography>
            <Index.List className="footer-user-list">
              <Index.ListItem className="footer-list-item-nav">
                <Index.Link
                  className="redirect-link-user"
                  to="https://www.facebook.com/ugooutapp/"
                  target="_blank"
                >
                  <img
                    src={PagesIndex.Svg.facebook}
                    alt="facebook"
                    className="footer-user-icon"
                  />
                </Index.Link>
              </Index.ListItem>
              <Index.ListItem className="footer-list-item-nav">
                <Index.Link
                  className="redirect-link-user"
                  to="https://www.instagram.com/ugoout.app/"
                  target="_blank"
                >
                  <img
                    src={PagesIndex.Svg.instagram}
                    alt="instagram"
                    className="footer-user-icon"
                  />
                </Index.Link>
              </Index.ListItem>
              <Index.ListItem className="footer-list-item-nav">
                <Index.Link
                  className="redirect-link-user"
                  to="/"
                  target="_blank"
                >
                  <img
                    src={PagesIndex.Svg.strem}
                    alt="strem"
                    className="footer-user-icon"
                  />
                </Index.Link>
              </Index.ListItem>
            </Index.List>
          </Index.Box>
          <Index.Box className="footer-user-flex">
            <Index.Box className="footer-user-logo">
              <Index.Link className="footer-user-logoimg">
                <img src={PagesIndex.Png.logougoout} alt="logougoout" />
              </Index.Link>
            </Index.Box>

            <Index.Box className="footer-link-contain">
              <Index.List className="footer-list-user">
                <Index.ListItem className="footer-list-item-nav">
                  <Index.Link className="redirect-link-user" to={"/privacy-policy"}>
                    Privacy Policy
                  </Index.Link>
                </Index.ListItem>
                <Index.ListItem className="footer-list-item-nav">
                  <Index.Link to={"/terms-condition"} className="redirect-link-user">
                    Terms of Services
                  </Index.Link>
                </Index.ListItem>
              </Index.List>
            </Index.Box>

            <Index.Box className="footer-user-copyright">
              <Index.Typography
                variant="body1"
                component="p"
                className="footer-user-typo"
              >
                Copyright © 2025
              </Index.Typography>
            </Index.Box>
          </Index.Box>
        </Index.Box>
      </Index.Box>
    </>
  );
};

export default Footer;
